"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Handle Page top button
 */
const jump_js_1 = __importDefault(require("jump.js"));
exports.default = () => {
    const $el = document.querySelector('.p-PageTop_Button');
    if ($el) {
        $el.addEventListener('click', onClick, false);
    }
};
const onClick = (event) => (0, jump_js_1.default)('html, body');
